// Link — internal navigation per COMPONENTS §Reuse rules.
//
// Wraps React Router 7's <Link>. INFO-colored text + underline-on-hover — links use
// the semantic info color, NOT the brand: a link should read as "navigable" without
// inheriting a flashy brand palette, and brand stays reserved for primary actions
// (DESIGN-TOKENS §Color). External links are NOT this primitive's job — they're a
// separate concern (open in new tab, aria-label noting "external", etc.).

import { Link as RouterLink, type LinkProps as RouterLinkProps } from 'react-router-dom';
import type { ReactNode } from 'react';

export interface LinkProps extends Omit<RouterLinkProps, 'children'> {
  children: ReactNode;
}

const linkClass =
  'text-[var(--color-info)] underline-offset-2 hover:underline ' +
  'outline-none focus-visible:rounded-sm focus-ring';

export function Link({ className = '', children, ...props }: LinkProps) {
  return (
    <RouterLink className={`${linkClass} ${className}`} {...props}>
      {children}
    </RouterLink>
  );
}
